import { useEffect, useId, useRef, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/** Native dialog owns focus containment, Escape and the inert background. */
export default function MobileSheet({ open, title, onClose, children }: {
  open: boolean; title: string; onClose: () => void; children: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useEffect(() => {
    if (!open) return;
    const previous = document.activeElement as HTMLElement | null;
    const dialog = ref.current!;
    dialog.showModal();
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      dialog.close();
      document.body.style.overflow = overflow;
      if (previous?.isConnected) previous.focus({ preventScroll: true });
    };
  }, [open]);
  useEffect(() => { if (open) ref.current?.querySelector<HTMLButtonElement>('header button')?.focus(); }, [open, title]);
  return createPortal(<dialog ref={ref} className="mobile-sheet" aria-labelledby={titleId}
    onCancel={(event) => { event.preventDefault(); onClose(); }}
    onClick={(event) => { if (event.target === ref.current) onClose(); }}>
    <div className="mobile-sheet-inner">
      <div className="mobile-sheet-handle" aria-hidden />
      <header><h2 id={titleId}>{title}</h2><button type="button" onClick={onClose}>Close</button></header>
      <div className="mobile-sheet-body">{children}</div>
    </div>
  </dialog>, document.body);
}
